/**
 * Banner Ad Component for Direct Advertising
 * 
 * Use this for selling ad space directly to advertisers
 * Price: R$ 200-2000/month depending on traffic
 * 
 * Usage:
 * <BannerAd 
 *   imageUrl="/ads/banner-1.jpg"
 *   link="https://advertiser-site.com"
 *   altText="Advertiser Name"
 * />
 */
const BannerAd = ({ 
  imageUrl, 
  link, 
  altText = 'Advertisement',
  size = 'medium' // small, medium, large
}) => {
  const sizes = {
    small: 'h-24',
    medium: 'h-32',
    large: 'h-48'
  };

  // Placeholder when no ad is configured
  if (!imageUrl) {
    return (
      <div className={`bg-slate-100 border border-slate-200 rounded-lg ${sizes[size]} flex items-center justify-center mb-8`}>
        <div className="text-center">
          <p className="text-slate-500 font-medium">Espaço Publicitário Disponível</p>
          <p className="text-xs text-slate-400 mt-1">Entre em contato para anunciar aqui</p>
        </div>
      </div>
    );
  }

  return (
    <div className="mb-8" data-testid="banner-ad">
      <a 
        href={link} 
        target="_blank" 
        rel="noopener noreferrer sponsored"
        onClick={() => {
          // Track banner clicks (optional - can integrate with analytics)
          if (window.gtag) {
            window.gtag('event', 'banner_click', {
              banner_name: altText
            });
          }
        }}
      >
        <img 
          src={imageUrl} 
          alt={altText}
          className={`w-full ${sizes[size]} object-cover rounded-lg hover:opacity-90 transition-opacity`}
          loading="lazy"
        />
      </a>
      <p className="text-xs text-slate-400 mt-1 text-center">Publicidade</p>
    </div>
  );
};

export default BannerAd;